import React from 'react';
import styled from 'styled-components';

import { useFeatureFlags } from './useFeatureFlags';

export const useSandboxPayment = (): boolean => {
  const availableFeatures = useFeatureFlags();
  return availableFeatures.includes('PAYMENT_SANDBOX');
};

/**
 * HOC for legacy class component support
 */
export function withSandboxPayment<P>(
  WrappedComponent: React.ComponentType<P & WithSandboxPayment>
): React.ComponentType<P> {
  function WithSandboxPayment(props: P) {
    const usingSandboxPayment = useSandboxPayment();

    return (
      <WrappedComponent usingSandboxPayment={usingSandboxPayment} {...props} />
    );
  }

  return WithSandboxPayment;
}

export interface WithSandboxPayment {
  usingSandboxPayment: boolean;
}

const Stypes = styled.div`
  border: 2px solid red;
  padding: 0.5rem;
`;

const SandboxBannerStyles = styled.h5`
  color: red;
  text-align: center;
`;

export const SandboxBanner = () => (
  <Stypes>
    <SandboxBannerStyles>SANDBOX PAYMENT IN EFFECT</SandboxBannerStyles>
    <p>
      To test stripe payments, use{' '}
      <a
        href="https://stripe.com/docs/testing#cards"
        target="_blank"
        rel="noreferrer"
      >
        cards provided by stripe
      </a>
      .
    </p>
  </Stypes>
);
